<table mat-table class="mt-3 w-100" (matSortChange)="sortData($event)" matSort matSortActive="senItemID"
    matSortDisableClear matSortDirection="asc" [dataSource]="dataSource">
    <ng-container matColumnDef="senItemID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{translate.getLng('ARTNO')}} </th>
        <td mat-cell *matCellDef="let element"> {{element.senItemID}} </td>
        <td mat-footer-cell *matFooterCellDef class="pr-5 text-right" [attr.colspan]="5">
            <!-- {{translate.getLng('TOTAL_EXCLUSIVE_OF_VAT')}} -->
        </td>
    </ng-container>
    <ng-container matColumnDef="imageURL">
        <th mat-header-cell *matHeaderCellDef> {{translate.getLng('ITEM_IMAGE')}}</th>
        <td mat-cell *matCellDef="let element"> <img width="40" src="{{element.imageURL}}"> </td>
        <td mat-footer-cell *matFooterCellDef class="d-none"></td>
    </ng-container>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{translate.getLng('NAME')}}</th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        <td Nmat-footer-cell *matFooterCellDef class="d-none"></td>
    </ng-container>
    <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{translate.getLng('QUANTITY')}}</th>
        <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
        <td mat-footer-cell *matFooterCellDef class="d-none"></td>
    </ng-container>
    <ng-container matColumnDef="unit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{translate.getLng('UNIT')}} </th>
        <td mat-cell *matCellDef="let element"> {{element.unit}} </td>
        <td mat-footer-cell *matFooterCellDef class="d-none"> </td>
    </ng-container>
    <ng-container matColumnDef="price">
        <th class="sen-price-cell" mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td class="text-right pr-3" mat-cell *matCellDef="let element"></td>
        <td class="text-right" mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns" colspan="5"></tr>
</table>
